import { useState } from "react";
import { toast } from "sonner";
import { Mail, UserPlus } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { Field } from "./common";
import { Modal } from "./shared";
import { useLang } from "../lib/i18n";

export function NewSubcontractorButton({ onSaved }) {
  const { tr } = useLang();
  const [open, setOpen] = useState(false);
  const empty = { company_name: "", vat_number: "", manager_name: "", email: "", password: "", sheet_name: "" };
  const [f, setF] = useState(empty);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const save = async () => {
    try {
      await api.post("/subcontractors", f);
      toast.success("Sous-traitant créé (société + compte)");
      setOpen(false);
      setF(empty);
      onSaved();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const fields = [["company_name", "Nom de la société"], ["vat_number", "Numéro de TVA"], ["manager_name", "Nom du gérant"],
    ["email", "E-mail (identifiant)", "email"], ["password", "Mot de passe (8 car. min.)", "password"], ["sheet_name", "Feuille Excel (facultatif, ex. KENAN)"]];
  return (
    <>
      <button className="tl-btn tl-btn-dark mb-3 mr-2" onClick={() => setOpen(true)} data-testid="new-subcontractor-button"><UserPlus size={16} /> {tr("Nouveau sous-traitant")}</button>
      {open && (
        <Modal title="Nouveau sous-traitant" onClose={() => setOpen(false)} testid="new-subcontractor-form">
          <div className="space-y-3">
            {fields.map(([k, l, t]) => (
              <Field key={k} label={l}><input type={t || "text"} className="tl-input" value={f[k]} onChange={set(k)} data-testid={`sub-${k}`} /></Field>
            ))}
            <button className="tl-btn tl-btn-primary w-full" onClick={save} data-testid="new-subcontractor-save">Créer la société et le compte</button>
          </div>
        </Modal>
      )}
    </>
  );
}

export function EmailCompanyButton({ companyId, subject }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ subject, message: "" });
  const send = async () => {
    try {
      const { data } = await api.post("/notifications/email", { company_id: companyId, ...f });
      toast.success(`E-mail envoyé (${data.sent})`);
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <>
      <button className="tl-btn tl-btn-ghost tl-btn-sm" onClick={() => setOpen(true)} data-testid="email-company-button"><Mail size={14} /> Prévenir le sous-traitant par e-mail</button>
      {open && (
        <Modal title="E-mail au sous-traitant" onClose={() => setOpen(false)} testid="email-company-form">
          <div className="space-y-3">
            <Field label="Objet"><input className="tl-input" value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="email-company-subject" /></Field>
            <Field label="Message"><textarea className="tl-textarea" rows={5} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="email-company-message" /></Field>
            <button className="tl-btn tl-btn-primary w-full" disabled={!f.message.trim()} onClick={send} data-testid="email-company-send">Envoyer</button>
          </div>
        </Modal>
      )}
    </>
  );
}
